import { render } from "./StuffTab.vue?vue&type=template&id=2c76511d"
import script from "./StuffTab.vue?vue&type=script&lang=js"
export * from "./StuffTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__